import "bootstrap/dist/css/bootstrap.min.css";

const ToggleSwitch = ({ handleToggle, toggle }) => {
  const toggleSwitch = () => {
    if (handleToggle) handleToggle(!toggle); // Directly update state in parent
  };

  return (
    <div className="d-flex align-items-center p-2">
      <div
        className="toggle-container"
        onClick={toggleSwitch}
        style={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          backgroundColor: toggle ? "#28a745" : "#9F9F9F",
          borderRadius: "0.3rem",
          width: "50px",
          height: "20px",
          position: "relative",
          transition: "background-color 0.3s",
          border: toggle ? "1px solid #28a745" : "1px solid #999",
        }}
      >
        <span
          style={{
            position: "absolute",
            left: toggle ? "calc(100% - 25px)" : "0",
            width: "25px",
            height: "20px",
            backgroundColor: "#fff",
            borderRadius: "4px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "10px",
            fontWeight: "bold",
            border: "1px solid #9F9F9F",
            color: "#000",
            transition: "left 0.3s",
            userSelect: "none"
          }}
        >
          {toggle ? "ON" : "OFF"}
        </span>
      </div>
      <span className="ms-2">Legends</span>
    </div>
  );
};

export default ToggleSwitch;
